import { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { Button } from '../../components/Button.js';
import { Input } from '../../components/Input.js';
import { useAuth } from './useAuth.js';

export function RegisterView() {
  const { signUpWithEmail } = useAuth();
  const navigate = useNavigate();

  const [nickname, setNickname] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signUpWithEmail(email, password, nickname);
      navigate('/map', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'アカウント作成に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6 bg-white">
      <img src="/favicon.svg" alt="RideHub" className="w-24 h-24 mb-2" />
      <p className="text-gray-500 mb-8">アカウントを作成</p>

      <form onSubmit={handleSubmit} className="w-full max-w-sm flex flex-col gap-4">
        <Input
          label="ニックネーム"
          type="text"
          value={nickname}
          onChange={(e) => setNickname(e.target.value)}
          required
          maxLength={50}
        />
        <Input
          label="メールアドレス"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="email"
        />
        <Input
          label="パスワード"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="new-password"
          hint="8文字以上"
        />

        {error && <p className="text-sm text-red-500">{error}</p>}

        <Button type="submit" loading={loading} size="lg" className="w-full">
          アカウントを作成
        </Button>

        <p className="text-center text-sm text-gray-500">
          すでにアカウントをお持ちの方は{' '}
          <Link to="/login" className="text-primary hover:underline">
            ログイン
          </Link>
        </p>
      </form>
    </div>
  );
}
